import { Injectable } from '@angular/core';

@Injectable()
export abstract class UpdateModelCardStrategy {
  abstract imgSrc: string;
  abstract title: string;
  abstract description: string;
  abstract cardClassName: string | undefined;
}
